import { render, staticRenderFns } from "./MerchantUpdate.vue?vue&type=template&id=3e11c5aa"
import script from "./MerchantUpdate.vue?vue&type=script&lang=js"
export * from "./MerchantUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports